/**
 * Роли пользователей
 */
export const UserRole = {
    USER: 'USER',
    MODERATOR: 'MODERATOR',
    ADMIN: 'ADMIN'
};

/**
 * Проверка, имеет ли пользователь роль администратора
 * @param {Object|null} user - Пользователь из UserContext
 * @returns {boolean}
 */
export const isAdmin = (user) => {
    return user?.role === UserRole.ADMIN;
};

/**
 * Проверка, имеет ли пользователь роль модератора или администратора
 * @param {Object|null} user - Пользователь из UserContext
 * @returns {boolean}
 */
export const isModerator = (user) => {
    return user?.role === UserRole.MODERATOR || user?.role === UserRole.ADMIN;
};

/**
 * Проверка, имеет ли пользователь доступ к админ-панели
 * @param {Object|null} user - Пользователь из UserContext
 * @returns {boolean}
 */
export const hasAdminAccess = (user) => {
    return isAdmin(user) || isModerator(user);
};

/**
 * Проверка, имеет ли пользователь доступ к модерации
 * @param {Object|null} user - Пользователь из UserContext
 * @returns {boolean}
 */
export const hasModerationAccess = (user) => {
    return isModerator(user);
};
